<template>
  <div class="wrapper">
    <div class="wrapperitem">
      <div class="head-content van-hairline--bottom">
        <van-row>
          <van-col>
            <img
              @click="onClickArrow(object)"
              class="item-img"
              :src="
                object.logoPictureUrl
                  ? object.logoPictureUrl
                  : 'https://img.yzcdn.cn/vant/cat.jpeg'
              "
            />
          </van-col>
          <van-col class="text-content" span="13">
            <div class="van-ellipsis" @click="onClickArrow(object)">
              {{ object.name }}
            </div>
            <div class="van-ellipsis address-head">
              <van-icon name="location-o" /><span class="text-address">{{
                object.address
              }}</span>
            </div>
          </van-col>
          <van-col span="5">
            <div class="van-ellipsis" v-if="object.distance">
              <img class="flyicon" :src="require('@/assets/images/fly.png')" />
              <span class="meter">{{ formatDistance(object.distance) }}</span>
            </div>
          </van-col>
        </van-row>
      </div>
      <div v-if="object.products">
        <div
          @click="skipProductOne(object)"
          class="new-goods"
          v-if="object.products.length === 1"
        >
          <div class="goods-price">
            <div class="discount-price">￥{{ object.products[0].price }}</div>
            <div v-if="object.products[0].marketPrice" class="price">
              原价￥{{ object.products[0].marketPrice }}
            </div>
          </div>
          <div class="goods-text van-ellipsis">
            <div class="van-ellipsis">
              {{ object.products[0].title }}
            </div>
            <div class="sales-num van-ellipsis">
              已售{{ object.products[0].salesVolume }}
            </div>
          </div>
        </div>
        <div v-if="object.products.length > 1 && object.products.length <= 2">
          <div
            @click="skipProductOne(object)"
            class="new-goods van-hairline--bottom"
          >
            <div class="goods-price">
              <div class="discount-price">￥{{ object.products[0].price }}</div>
              <div v-if="object.products[0].marketPrice" class="price">
                原价￥{{ object.products[0].marketPrice }}
              </div>
            </div>
            <div class="goods-text van-ellipsis">
              <div class="van-ellipsis">
                {{ object.products[0].title }}
              </div>
              <div class="sales-num van-ellipsis">
                已售{{ object.products[0].salesVolume }}
              </div>
            </div>
          </div>
          <div
            @click="skipProductTwo(object)"
            class="new-goods van-hairline--bottom"
          >
            <div class="goods-price">
              <div class="discount-price">￥{{ object.products[1].price }}</div>
              <div v-if="object.products[1].marketPrice" class="price">
                原价￥{{ object.products[1].marketPrice }}
              </div>
            </div>
            <div class="goods-text van-ellipsis">
              <div class="van-ellipsis">
                {{ object.products[1].title }}
              </div>
              <div class="sales-num van-ellipsis">
                已售{{ object.products[1].salesVolume }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="object.products.length > 2">
          <div v-if="moreBtn">
            <div
              @click="skipProductOne(object)"
              class="new-goods van-hairline--bottom"
            >
              <div class="goods-price">
                <div class="discount-price">
                  ￥{{ object.products[0].price }}
                </div>
                <div v-if="object.products[0].marketPrice" class="price">
                  原价￥{{ object.products[0].marketPrice }}
                </div>
              </div>
              <div class="goods-text van-ellipsis">
                <div class="van-ellipsis">
                  {{ object.products[0].title }}
                </div>
                <div class="sales-num van-ellipsis">
                  已售{{ object.products[0].salesVolume }}
                </div>
              </div>
            </div>
            <div
              @click="skipProductTwo(object)"
              class="new-goods van-hairline--bottom"
            >
              <div class="goods-price">
                <div class="discount-price">
                  ￥{{ object.products[1].price }}
                </div>
                <div v-if="object.products[1].marketPrice" class="price">
                  原价￥{{ object.products[1].marketPrice }}
                </div>
              </div>
              <div class="goods-text van-ellipsis">
                <div class="van-ellipsis">
                  {{ object.products[1].title }}
                </div>
                <div class="sales-num van-ellipsis">
                  已售{{ object.products[1].salesVolume }}
                </div>
              </div>
            </div>
          </div>

          <div v-if="moreProdect">
            <div
              class="new-goods van-hairline--bottom"
              v-for="(item, i) in object.products"
              :key="i"
              @click="skipProductList(object, item)"
            >
              <div class="goods-price">
                <div class="discount-price">￥{{ item.price }}</div>
                <div v-if="item.marketPrice" class="price">
                  原价￥{{ item.marketPrice }}
                </div>
              </div>
              <div class="goods-text van-ellipsis">
                <div class="van-ellipsis">{{ item.title }}</div>
                <div class="sales-num van-ellipsis">
                  已售{{ item.salesVolume }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="object.products.length > 2" @click="downClick">
          <div v-if="moreBtn" class="more-btn">
            更多产品 (<span>{{ object.products.length - 2 }}</span
            >) V
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Businnesscard',
  props: {
    object: Object,
  },

  data() {
    return {
      moreProdect: false,
      moreBtn: true,
    }
  },

  methods: {
    formatDistance(distance) {
      if (distance > 10000) {
        return '>10km'
      }

      if (distance > 1000) {
        return distance / 1000 + 'km'
      }
      return distance + 'm'
    },
    skipProductOne(item) {
      this.skipRouter(item.id, item.products[0].id)
    },
    skipProductTwo(item) {
      this.skipRouter(item.id, item.products[1].id)
    },
    skipProductList(obj, item) {
      this.skipRouter(obj.id, item.id)
    },

    skipRouter(storeId, id) {
      this.$router.push({
        path: `/mall/detail`,
        query: {
          id: id,
          storeId: storeId,
        },
      })
    },
    downClick() {
      this.moreProdect = !this.moreProdect
      this.moreBtn = false
    },
    onHitProduct(item) {
      this.$router.push({
        path: '/detailspage/morestore/index',
        query: {
          id: item.id,
          storeId: item.salesStoreId,
        },
      })
    },
    onClickArrow(item) {
      this.$router.push({
        path: '/mall/company',
        query: {
          userId: item.userId,
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.wrapper {
  background-color: #fff;
  // width: 345px;
  border-radius: 5px;
}
.wrapperitem {
  margin: 10px 0;
  padding: 10px 0 10px 10px;
  .head-content {
    padding-bottom: 5px;
  }
  .item-img {
    width: 84px;
    height: 84px;
    border-radius: 5px;
  }
  .text-content {
    font-size: 15px;
    color: #121212;
    text-align: left;
    padding: 6px 0 0 10px;
    .text-label {
      font-size: 12px;
      border-radius: 3px;
      margin-top: 6px;
      padding: 2px;
      background-color: #f44d4d;
      width: 68px;
      text-align: center;
      color: #fff;
    }
    .address-head {
      padding-top: 40px;
      .text-address {
        color: #666666;
        font-size: 13px;
      }
    }
  }
  .arrow-icon {
    width: 30px;
    height: 30px;
    padding-top: 8px;
  }
  .flyicon {
    padding-top: 8px;
    width: 11.5px;
    height: 11.5px;
  }
  .meter {
    font-size: 14px;
    color: #878787;
  }
  // goods内容
  .new-goods {
    display: flex;
    justify-content: flex-start;
    .goods-price {
      text-align: left;
      width: 80px;
      padding: 8px 0px 8px 0;
      .discount-price {
        font-size: 16px;
        color: #C30D23;
        width: 80px;
      }
      .price {
        font-size: 10px;
        color: #898989;
        padding-top: 5px;
        width: 80px;
        text-decoration: line-through;
      }
    }
    .goods-text {
      padding: 8px 7px 8px 0;
      font-size: 15px;
      color: #3e3a39;
      .sales-num {
        font-size: 12px;
        color: #898989;
        text-align: left;
        padding-top: 5px;
      }
    }
  }
  .more-btn {
    padding-top: 10px;
    font-size: 14px;
    color: #666;
  }
}
</style>
